export enum SvelteTemplate {
	Homepage = "Homepage",
	NotFound = "NotFound",
	FrequentlyAskedQuestions = "FrequentlyAskedQuestions",
	AboutUs = "AboutUs",
	Contact = "Contact",
	Vouchers = "Vouchers",
	Procedure = "Procedure",
	ProcedureDetail = "ProcedureDetail",
	Blog = "Blog",
	BlogDetail = "BlogDetail",
	PrivacyPolicy = "PrivacyPolicy",
}

export enum SpecialTemplate {
	Sitemap = "Sitemap",
	Robots = "Robots",
	Redirect = "Redirect",
}

export const Template = {
	...SvelteTemplate,
	...SpecialTemplate,
};
export type Template = SvelteTemplate | SpecialTemplate;

export function isSvelteTemplate(template: Template): template is SvelteTemplate {
	return template in SvelteTemplate;
}

export function isSpecialTemplate(template: Template): template is SpecialTemplate {
	return template in SpecialTemplate;
}
